module.exports = __webpack_public_path__ + "img/5esport.700ff22e.jpeg";